import apiConfig from '../../globalConfig/apiConfig'
import { Modal, Spinner, useToaster } from '@enterprise-ui/canvas-ui-react'
import { useState } from 'react'
import { MicroFrontend } from '@praxis/component-microfrontend'
import { useNavigate } from 'react-router-dom'
import '../../globalStyles/itemCatalog.scss'
// TODO: Switch back to item-component Overlay post canvas 8 migration
// import { Overlay } from "item-component/canvas8"
import Overlay from '../../components/Overlay'
import { STATUS } from '../../constants/item-catalog-constants'

// Defined outside the hook to prevent remounting the MFE on every state change
const UploadModalContent = ({
  isUploadModalOpen,
  isOverlayOpen,
  childModalOpen,
  uploadMfeConfig,
  navigate,
  onRefuse,
  handleActionComplete,
  setChildModalOpen,
  setIsOverlayOpen,
  mfeReloadKey,
}) => (
  <>
    {/* TODO: Consume ContentModalLauncher & Overlay from item-component post canvas 8 migration */}
    <Modal
      headingText="Upload Item Data"
      size="md"
      isVisible={isUploadModalOpen}
      onRefuse={onRefuse}
    >
      <MicroFrontend
        key={`upload-${mfeReloadKey}`}
        src={uploadMfeConfig}
        module="./uploadStandard"
        Loading={() => (
          <Spinner
            size="lg"
            longWaitAriaAlert="Upload control is loading, please wait..."
          />
        )}
        isEmbedded={true}
        clientScope="lpSubmission"
        navigate={navigate}
        handleActionComplete={handleActionComplete}
        onChildModalVisibilityChange={setChildModalOpen}
        onActionInProgress={setIsOverlayOpen}
      />
    </Modal>
    {isOverlayOpen && (
      <Overlay
        showSpinner={false}
        longWaitAriaAlert="File upload in progress, please wait..."
      />
    )}
  </>
)

export const useUploadMfe = () => {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const [isOverlayOpen, setIsOverlayOpen] = useState(false)
  const [childModalOpen, setChildModalOpen] = useState(false)
  const [historyRefreshKey, setHistoryRefreshKey] = useState(0)
  const [mfeReloadKey] = useState(0)

  const uploadMfeConfig = `${apiConfig.remotes.bulkX}/remoteEntry.js`

  const navigate = useNavigate()
  const makeToast = useToaster()

  //Maintaining a separate function to handle the upload click, so that we can add any additional logic in future if needed like analytics and for readability.
  const handleUploadClick = () => {
    setIsUploadModalOpen(true)
  }

  const handleActionComplete = (payload) => {
    let variant = payload?.type || payload?.variant
    try {
      makeToast?.({
        // variant,
        type: variant, //TODO: Uncomment the above "variant" and remove this type post canvas 8 migration.
        heading: payload?.heading,
        message: payload?.message,
        links: payload?.links,
      })
    } catch (e) {
      console.error('Error showing toast', e)
    }
    // close host modal on success explicitly and refresh history
    if (variant?.toLowerCase() === STATUS.SUCCESS) {
      setHistoryRefreshKey((k) => k + 1)
    }
    setIsUploadModalOpen(false)
    setIsOverlayOpen(false)
  }

  const uploadModal = (
    <UploadModalContent
      isUploadModalOpen={isUploadModalOpen}
      isOverlayOpen={isOverlayOpen}
      childModalOpen={childModalOpen}
      uploadMfeConfig={uploadMfeConfig}
      navigate={navigate}
      onRefuse={() => {
        if (childModalOpen || isOverlayOpen) return
        setIsUploadModalOpen(false)
      }}
      handleActionComplete={handleActionComplete}
      setChildModalOpen={setChildModalOpen}
      setIsOverlayOpen={setIsOverlayOpen}
      mfeReloadKey={mfeReloadKey}
    />
  )

  return {
    handleUploadClick,
    uploadModal,
    historyRefreshKey,
    mfeReloadKey,
  }
}
